import axios from 'axios';
import Router from '../routes';
import store from '../store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  params: {}
});

instance.interceptors.request.use(
  (request) => {
    const token = store.getters['token/token'];

    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      return Promise.reject({
        message: 'Something went wrong'
      });
    }

    const { status, data } = error?.response;

    if (status === 401 || status === 500) {
      store.dispatch('error/updateState', { status, message: data.message });
      Router.push({ name: 'error', params: { status } });
    }

    return Promise.reject(error.response);
  }
);

export default instance;
